import React, { useState } from 'react';
import moment from 'moment';
import { withTheme } from 'styled-components';
import {
    ConfigProvider,
    Empty,
    Skeleton,
    Tooltip,
    Tabs
} from 'antd';

import { FlexColumn, LightContainer } from '../../Reusable/Container';
import { Text, Tag } from '../../Reusable/Text';
import { Flex } from '../../Reusable/Container';
import TableView from '../../Reusable/TableView';
import { Image } from '../../Reusable/Image'
import { MutedTabs } from '../../Reusable/MutedTabs'
import { LabeledInput } from '../../Reusable/Input';
import { TextButton } from '../../Reusable/Button';
import Info from '../../../Images/info.png'
import { getPreSignedS3Url } from '../../../Utils/api';
import { saveAs } from 'file-saver'
import { EditOutlined, PlusOutlined, FilePdfOutlined } from '@ant-design/icons';

const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

const dFormat = "ll; h:mm A z"
const etTimeZone = "America/New_York"

const { TabPane } = Tabs

const shortTermColumns = [
    {
        title: 'Advance ID',
        dataIndex: 'LoanId',
        width: 120
    },
    {
        title: 'Date',
        dataIndex: 'AdvanceDate',
        render: date => (moment(date).format('ll')),
        width: 120
    },
    {
        title: 'Amount',
        dataIndex: 'AdvanceAmount',
        render: amount => formatter.format(amount),
        // align: 'right'
    },
    {
        title: 'Type',
        dataIndex: 'ProductType',
    },
    {
        title: 'Status',
        dataIndex: 'LoanStatus',
    },
    {
        title: 'Note',
        dataIndex: 'AdvanceNotes'
    }
]

const customizeRenderEmpty = () => (
    <Empty
        imageStyle={{
            height: 60,
        }}
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={
            <span>
                No Advances
            </span>
        }>
    </Empty>
)

const getColumns = (props) => {
    const { theme } = props
    const openUpload = (e, item) => {
        props.openUpload(item);
        e.stopPropagation();
    }

    if (props.ifFeesAreToBeDrawn) {
        var columns = [
            {
                title: 'Draw ID',
                dataIndex: 'LoanId',
                width: '10%',
                align: 'center',
            },
            {
                title: 'Requested On',
                dataIndex: 'AdvanceDate',
                render: date => (moment(date).tz(etTimeZone).format(dFormat)),
                width: '15%',
                align: 'left',
            },
            {
                title: 'Draw Amount',
                dataIndex: 'AdvanceAmount',
                width: '15%',
                render: amount => formatter.format(amount),
                align: 'center',
            },
            {
                title: () => {
                    return <Flex center fullWidth gap='8px' centerHorizontally>
                        Fees <Tooltip overlayInnerStyle={{ minWidth: 300 }} overlayStyle={{ minWidth: 400 }} overlayClassName='roles-tooltip' placement="right" arrowPointAtCenter={false} title={<FlexColumn>
                            <Text color='white' size='14px' noWrap>Draw fees</Text>
                        </FlexColumn>}>
                            <FlexColumn>
                                <Image src={Info} />
                            </FlexColumn>
                        </Tooltip>
                    </Flex>
                },
                dataIndex: 'Fees',
                render: fees => fees == null ? formatter.format(0) : formatter.format(fees),
                width: "15%",
                align: 'center',
            },
            {
                title: 'Status',
                width: '15%',
                render: item => <Tag color={item.LoanStatus == "Initiated" ? theme.colors.primary : theme.colors.greenDeep} background={item.LoanStatus == "Initiated" ? theme.colors.backgroundPrimary : theme.colors.greenPale}>{item.LoanStatus == "Initiated" ? "Processing ".toUpperCase() : item.LoanStatus.toUpperCase()}</Tag>,
                align: 'center',
            },
            {
                title: 'Note',
                width: '30%',
                dataIndex: 'AdvanceNotes',
                align: 'left',
            }
            // {
            //     title: (
            //         <Popover content="Invoices used as collateral for the advance.">
            //             <span>Advanced Invoices </span>
            //             <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
            //         </Popover>
            //     ),
            //     dataIndex: 'ConstructedInvoices',
            //     width: 120,
            //     render: ConstructedInvoices => (
            //         (ConstructedInvoices || []).map(invoice => <Tag key={invoice.DocNumber}>{invoice.DocNumber}</Tag>)
            //     )
            // },
            // {
            //     title: 'Delivery Speed',
            //     dataIndex: 'ProductType',
            //     width: 120,
            //     render: type => {
            //         const { theme } = props

            //         return type && <Tag style={{ margin: "5px 0" }} tagpreset={theme.colors.secondary4}>{type.replace("Funding", "")}</Tag>
            //     },
            // },
        ]

        if (props.fromConsole) {
            columns.push({
                title: 'Action',
                render: (item) => item.AdditionalDetail ? <TextButton onClick={event => {
                    openUpload(event, item);
                }
                } rightIcon={<EditOutlined />} text="Edit Details" /> : <TextButton onClick={event => openUpload(event, item)} rightIcon={<PlusOutlined />} text="Add Details" />
            })
        }

        return columns;
    }
    else {
        var columns = [
            {
                title: 'Advance ID',
                dataIndex: 'LoanId',
                width: '15%',
                align: 'left',
            },
            {
                title: 'Requested On',
                dataIndex: 'AdvanceDate',
                render: date => (moment(date).tz(etTimeZone).format(dFormat)),
                width: '25%',
                align: 'center',
            },
            {
                title: 'Amount',
                dataIndex: 'AdvanceAmount',
                width: '15%',
                render: amount => formatter.format(amount),
                align: 'center',
            },
            {
                title: 'Status',
                width: '15%',
                render: item => <Tag color={item.LoanStatus == "Initiated" ? theme.colors.primary : theme.colors.greenDeep} background={item.LoanStatus == "Initiated" ? theme.colors.backgroundPrimary : theme.colors.greenPale}>{item.LoanStatus == "Initiated" ? "Processing ".toUpperCase() : item.LoanStatus.toUpperCase()}</Tag>,
                align: 'center',
            },
            {
                title: 'Note',
                width: '30%',
                dataIndex: 'AdvanceNotes',
                align: 'left',
            },
            // {
            //     title: (
            //         <Popover content="Invoices used as collateral for the advance.">
            //             <span>Advanced Invoices </span>
            //             <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
            //         </Popover>
            //     ),
            //     dataIndex: 'ConstructedInvoices',
            //     width: 120,
            //     render: ConstructedInvoices => (
            //         (ConstructedInvoices || []).map(invoice => <Tag key={invoice.DocNumber}>{invoice.DocNumber}</Tag>)
            //     )
            // },
            // {
            //     title: 'Delivery Speed',
            //     dataIndex: 'ProductType',
            //     width: 120,
            //     render: type => {
            //         const { theme } = props

            //         return type && <Tag style={{ margin: "5px 0" }} tagpreset={theme.colors.secondary4}>{type.replace("Funding", "")}</Tag>
            //     },
            // },
        ]

        if (props.fromConsole) {
            columns.push({
                title: 'Action',
                render: (item) => item.AdditionalDetail ? <TextButton onClick={event => {
                    openUpload(event, item);
                }
                } rightIcon={<EditOutlined />} text="Edit Details" /> : <TextButton onClick={event => openUpload(event, item)} rightIcon={<PlusOutlined />} text="Add Details" />
            })
        }

        return columns;
    }
}

const getShortTermColumns = (props) => {
    const { theme } = props
    const openUpload = (e, item) => {
        props.openUpload(item);
        e.stopPropagation();
    }

    if (props.ifFeesAreToBeDrawn) {
        var columns = [
            {
                title: 'Draw ID',
                // dataIndex: 'LoanId',
                align: 'left',
                width: "15%",
                render: (item) =>
                (
                    <Flex start style={{ whiteSpace: 'nowrap' }}>
                        <a style={{ textDecoration: "underline", color: "#1199FF" }} onClick={event => {
                            if (props.fromConsole) {
                                event.stopPropagation();
                                props.selectRow(item);
                            }
                        }}>{item.LoanId}</a>
                    </Flex>
                ),
            },
            {
                title: 'Requested On',
                dataIndex: 'AdvanceDate',
                render: date => (moment(date).tz(etTimeZone).format(dFormat)),
                width: "15%",
                align: 'center',
            },
            {
                title: 'Draw Amount',
                dataIndex: 'AdvanceAmount',
                render: amount => formatter.format(amount),
                width: "15%",
                align: 'center',
            },
            {
                title: () => {
                    return <Flex center fullWidth gap='8px' centerHorizontally>
                        Fees <Tooltip overlayInnerStyle={{ minWidth: 300 }} overlayStyle={{ minWidth: 400 }} overlayClassName='roles-tooltip' placement="right" arrowPointAtCenter={false} title={<FlexColumn>
                            <Text color='white' size='14px' noWrap>Draw fees</Text>
                        </FlexColumn>}>
                            <FlexColumn>
                                <Image src={Info} />
                            </FlexColumn>
                        </Tooltip>
                    </Flex>
                },
                dataIndex: 'Fees',
                render: fees => fees == null ? formatter.format(0) : formatter.format(fees),
                width: "15%",
                align: 'center',
            },
            {
                title: 'Status',
                render: item => <Tag color={item.LoanStatus == "Initiated" ? theme.colors.primary : theme.colors.greenDeep} background={item.LoanStatus == "Initiated" ? theme.colors.backgroundPrimary : theme.colors.greenPale}>{item.LoanStatus == "Initiated" ? "Processing ".toUpperCase() : item.LoanStatus.toUpperCase()}</Tag>,
                width: "15%",
                align: 'center',
            },
            {
                title: 'Note',
                dataIndex: 'AdvanceNotes',
                width: "40%",
                render: note => note ? note : "--",
                align: 'left',
            }
        ]

        if (props.fromConsole) {
            columns.push({
                title: 'Action',
                render: (item) => item.AdditionalDetail ? <TextButton onClick={event => {
                    openUpload(event, item);
                }
                } rightIcon={<EditOutlined />} text="Edit Details" /> : <TextButton onClick={event => openUpload(event, item)} rightIcon={<PlusOutlined />} text="Add Details" />
            })
        }

        return columns;
    }
    else {
        var columns = [
            {
                title: 'Advance ID',
                // dataIndex: 'LoanId',
                align: 'left',
                width: "15%",
                render: (item) =>
                (
                    <Flex start style={{ whiteSpace: 'nowrap' }}>
                        <a style={{ textDecoration: "underline", color: "#1199FF" }} onClick={event => {
                            if (props.fromConsole) {
                                event.stopPropagation();
                                props.selectRow(item);
                            }
                        }}>{item.LoanId}</a>
                    </Flex>
                )
            },
            {
                title: 'Requested On',
                dataIndex: 'AdvanceDate',
                render: date => (moment(date).tz(etTimeZone).format(dFormat)),
                width: "15%",
                align: 'center',
            },
            {
                title: 'Amount',
                dataIndex: 'AdvanceAmount',
                render: amount => formatter.format(amount),
                width: "15%",
                align: 'center',
            },
            {
                title: 'Status',
                render: item => <Tag color={item.LoanStatus == "Initiated" ? theme.colors.primary : theme.colors.greenDeep} background={item.LoanStatus == "Initiated" ? theme.colors.backgroundPrimary : theme.colors.greenPale}>{item.LoanStatus == "Initiated" ? "Processing ".toUpperCase() : item.LoanStatus.toUpperCase()}</Tag>,
                width: "15%",
                align: 'center',
            },
            {
                title: 'Note',
                dataIndex: 'AdvanceNotes',
                width: "40%",
                render: note => note ? note : "--",
                align: 'left',
            }
        ]

        if (props.fromConsole) {
            columns.push({
                title: 'Action',
                render: (item) => item.AdditionalDetail ? <TextButton onClick={event => {
                    openUpload(event, item);
                }
                } rightIcon={<EditOutlined />} text="Edit Details" /> : <TextButton onClick={event => openUpload(event, item)} rightIcon={<PlusOutlined />} text="Add Details" />
            })
        }

        return columns;
    }
}

// Download Individual Doc
const downloadDoc = (item) => {
    const urlArr = item.URI.split('.');
    var fileExtension = urlArr[urlArr.length - 1];
    var filename = (item.FileName).includes(fileExtension) ? item.FileName : item.FileName + "." + fileExtension;
    getPreSignedS3Url({ url: item.URI }, async (err, preSignedUrl) => {
        try {
            // prevents opening file in new tab
            let blob = await fetch(preSignedUrl).then((r) => r.blob());
            saveAs(blob, filename);

        } catch (err) {
            console.log(err);
        }
    })
}

const getRowDetails = (record, props) => {
    const { theme } = props
    var { id } = record
    return (
        <MutedTabs key={`${id}-detailsTabs`} size="large" defaultActiveKey="receiptsReceived">
            {
                <TabPane tab="Additional Details" key="additionalDetails">
                    <LightContainer fullWidth>
                        <Flex style={{ width: "100%", padding: "20px", justifyContent: "space-between", alignItems: 'flex-start' }}>
                            <FlexColumn style={{ width: "100%" }}>
                                <LightContainer fullWidth>
                                    <Flex start wrap gap='24px'>
                                        <LabeledInput
                                            label='Note'
                                            key={`${id}-note`}
                                            nomargin
                                            type='read-only'
                                            value={record.AdditionalDetail && record.AdditionalDetail.Note ? record.AdditionalDetail.Note : '--'}
                                        />
                                    </Flex>
                                    <Flex start wrap style={{ marginTop: 10 }}>
                                        <Text color={'#7384AA'} size='14px' margin='0 0 4px' weight={400}>Documents</Text>
                                    </Flex>
                                    <Flex start wrap gap='24px'>
                                        <Flex start>
                                            {
                                                record && record.AdditionalDetail && record.AdditionalDetail.Documents && record.AdditionalDetail.Documents.length > 0 ?
                                                    <Flex start style={{ flexWrap: "wrap", gap: 16 }}>
                                                        {
                                                            record && record.AdditionalDetail && record.AdditionalDetail.Documents
                                                            && record.AdditionalDetail.Documents.map((file, i) => {
                                                                return (
                                                                    <>
                                                                        <TextButton
                                                                            noBorder height='32px' padding='4px 8px' radius='4px' background='#F8F8F8' key={i} color="#40a9ff"
                                                                            onClick={() => downloadDoc(file)}
                                                                            icon={<FilePdfOutlined style={{ fontSize: 14, color: "#40a9ff" }} />} text={file.FileName} />
                                                                    </>
                                                                );
                                                            })
                                                        }
                                                    </Flex>
                                                    : '--'
                                            }
                                        </Flex>
                                    </Flex>
                                </LightContainer>
                            </FlexColumn>
                        </Flex>
                    </LightContainer>
                </TabPane>
            }
        </MutedTabs>
    )
}

function AdvancesTable(props) {
    const [selectedRowId, setSelectedRowId] = useState(null)

    var items = props.data || [];
    items.sort(function (a, b) {
        return moment(b.AdvanceDate).toDate() - moment(a.AdvanceDate).toDate();
    });
    return (
        <FlexColumn>
            {/* <Text size='20px' margin='0 0 24px 0'>History</Text> */}
            <ConfigProvider renderEmpty={customizeRenderEmpty}>
                <div className="config-provider">
                    <Skeleton loading={!props.advancesLoaded} active title={false} paragraph={{ rows: 4 }}>
                        <TableView
                            id='advances-table'
                            titleText='Advance History'
                            rowKey='Id'
                            tableLayout='auto'
                            columns={(props.type == "short-term") ? getShortTermColumns(props) : getColumns(props)}
                            dataSource={items}
                            onRow={(record) => props.allowRowClick ? ({
                                onClick: () => {
                                    if (!props.fromConsole) {
                                        props.selectRow(record);
                                    } else {
                                        if (record['Id'] == selectedRowId) {
                                            setSelectedRowId(null)
                                        } else {
                                            setSelectedRowId(record['Id'])
                                            getRowDetails(record, props)
                                        }
                                    }
                                },
                            }) : {
                                onClick: () => {
                                    if (record['Id'] == selectedRowId) {
                                        setSelectedRowId(null)
                                    } else {
                                        setSelectedRowId(record['Id'])
                                        getRowDetails(record, props)
                                    }
                                }
                            }}
                            ctaContent={props.ctaContent}
                            expand={props.expand != false} // ON by default
                            expandedRowKey={selectedRowId}
                            getRowDetails={(record) => getRowDetails(record, props)}
                        />
                    </Skeleton>
                </div>
            </ConfigProvider>
        </FlexColumn>
    )
}

export default withTheme(AdvancesTable);